<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <router-link :to="{ name: 'Home' }" class="navbar-brand" tag="a">
      KRBS CIRCULARS
    </router-link>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link :to="{name : 'Home'}" class="nav-link"
                       :class="{ 'active': isRouteActive('Home')}"
                       style="font-size:14px;"
                       href="#">
            <font-awesome-icon icon="house" class="ml-2 mr-1" />
            Home <span class="sr-only">(current)</span>
          </router-link>
        </li>
        <li class="nav-item" v-show="isStaff">
          <router-link :to="{ name: 'UserMemoView' }" class="nav-link"
                       :class="{ 'active': isRouteActive('UserMemoView')}"
                       style="font-size:14px;">
            <font-awesome-icon icon="sticky-note" class="ml-2 mr-1" />
            Memo Viewed
          </router-link>
        </li>
        <li class="nav-item">
          <a role="button" class="nav-link" style="font-size:14px;" @click="tvLogin">
            <font-awesome-icon icon="video" class="ml-2 mr-1" />
            Training Videos</a>
        </li>
        <li class="nav-item">
          <a role="button" class="nav-link" style="font-size:14px;" @click="ttosLogin">
            <font-awesome-icon icon="display" class="ml-2 mr-1" />
            TTOS Presentations</a>
        </li>
      </ul>

      <div class="navbar-nav ml-auto ml-md-0">
        <div class="nav-item mr-2">
          <a class="nav-link text-white p-0" id="fullName" style="font-size:14px;" href="#">
            <font-awesome-icon icon="user" class="ml-2 mr-1" />
            {{ userFullName }}
          </a>
          <small for="fullName" class="text-white" style="font-size: 10px;">{{ userPosition }}</small>
        </div>
      </div>

      <ul class="navbar-nav ml-auto ml-md-0" v-show="isStaff">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="userDropdown" href="#" role="button" data-toggle="dropdown"
             aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="user-shield" class="ml-2 mr-1" />
            <span style="font-size:14px;">Administrator</span>
          </a>

          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">

            <div class="dropdown-divider"></div>
            <router-link :to="{name : 'ManningReport'}" class="dropdown-item"
                         :class="{ 'active': isRouteActive('ManningReport')}"
                         href="#">
              <font-awesome-icon icon="chart-column" class="ml-2 mr-1" />
              Report #1
            </router-link>

            <router-link :to="{name : 'CrewSearch'}" class="dropdown-item"
                         :class="{ 'active': isRouteActive('CrewSearch')}"
                         href="#">
              <font-awesome-icon icon="chart-column" class="ml-2 mr-1" />
              Report #2
            </router-link>

            <router-link :to="{name : 'CrewPerManningReport'}" class="dropdown-item"
                         :class="{ 'active': isRouteActive('CrewPerManningReport')}"
                         href="#">
              <font-awesome-icon icon="chart-column" class="ml-2 mr-1" />
              Report #3
            </router-link>

          </div>
        </li>
      </ul>


      <ul class="navbar-nav ml-auto ml-md-0">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="userDropdown" href="#" role="button" data-toggle="dropdown"
             aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="gear" class="ml-2 mr-1" />
            <span style="font-size:14px;">Account</span>
          </a>

          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
            <a class="dropdown-item" href="#"
               v-if="isStaff"
               data-toggle="modal" data-target="#change-user-password">
              <font-awesome-icon icon="shield-halved" class="ml-2 mr-1" />
              Change Password
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="thisLogOut">
              <font-awesome-icon icon="arrow-right-from-bracket" class="ml-2 mr-1" />
              Logout
            </a>
          </div>
          <change-user-password />

        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {AppMixins} from '@/mixins/app.mixins';

import {
  TV_URL,
  TTOS_URL,
} from '@/config/constants.config';

import ChangeUserPassword from '@/components/ChangeUserPassword';
import {UacMixins} from '@/mixins/uac.mixins';

export default {
  name: 'Nav',

  /** mixins **/
  mixins: [AppMixins, UacMixins],

  components: {ChangeUserPassword},

  /** methods**/
  methods: {
    ...mapActions(
        [
          'logoutUser',
        ],
    ),
    // async thisLogOut() {
    //   let logout=await this.logoutUser();
    //    if(!logout || logout){
    //       localStorage.clear();
    //      await this.$router.push({name: 'Login'});
    //    }
    // },

    thisLogOut() {
      this.$nextTick(() => {
        this.logoutUser().then((r) => {
          if (r) {
            localStorage.clear();
            this.$router.push({name: 'Login'});
            location.reload();
          }
          location.reload();
        });
      });
    },

    tvLogin() {
      let loggedInUser = JSON.parse(localStorage.getItem('loggedInUser'));
      let userType = loggedInUser.is_staff ? 'stafflogin' : 'crewlogin';
      let url = `${TV_URL}/${userType}/${loggedInUser.username}/${loggedInUser.password}`;
      window.location.href = url;
    },

    ttosLogin() {
      let loggedInUser = JSON.parse(localStorage.getItem('loggedInUser'));
      let userType = loggedInUser.is_staff ? 'stafflogin' : 'crewlogin';
      let url = `${TTOS_URL}/${userType}/${loggedInUser.username}/${loggedInUser.password}`;
      window.location.href = url;
    },

  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'authUser',
        ],
    ),
  },

};
</script>

<style scoped>
@media (min-width: 576px) {

  nav{
    background-color: red;
  }

}
</style>
